interface ErrorWithMessage {
  message: string;
}

/**
 * Checks if the provided error object has a "message" property of type string.
 *
 * @param error - The error object to check.
 * @returns A boolean indicating whether the error has a "message" property of type string.
 */
export const isErrorWithMessage = (error: unknown): error is ErrorWithMessage =>
  typeof (error as Record<string, unknown>)?.message === 'string';

/**
 * Converts a value to an ErrorWithMessage object.
 *
 * @param maybeError - The value to convert.
 * @returns An ErrorWithMessage object.
 */
export const toErrorWithMessage = (maybeError: unknown): ErrorWithMessage => {
  if (isErrorWithMessage(maybeError)) return maybeError;

  try {
    return new Error(JSON.stringify(maybeError));
  } catch {
    return new Error(String(maybeError));
  }
};

/**
 * Retrieves the error message from the given error object.
 *
 * @param error - The error object.
 * @returns The error message.
 */
export const getErrorMessage = (error: unknown) =>
  toErrorWithMessage(error).message;
